var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.event.event_class === _vm.Event.CLASS_EVENT)?_c('schedule-edit-dialog-event-main-container',{attrs:{"record":_vm.record,"event":_vm.event}}):_c('schedule-edit-dialog-default-main-container',{attrs:{"record":_vm.record,"event":_vm.event}})
}
var staticRenderFns = []

export { render, staticRenderFns }